<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">Legal Entity</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="
              merchant.accountDetails.worldPayAccountDetails
                .backingWPMerchantExists &&
              isUserBase() &&
              isWorldPay() &&
              isMerchantActive() &&
              !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Legal Entity
          </button>
        </div>
      </legend>

      <div class="mt-3" *ngIf="!editable">
        <app-legal-entity [merchant]="merchant"></app-legal-entity>
      </div>

      <div class="mt-3" *ngIf="editable">
        <form
          name="generalInfoFormControl"
          class="form-horizontal"
          novalidate
          [formGroup]="wpLegalEntityForm"
          (submit)="updateLegalEntity()"
        >
          <app-legal-entity-edit
            [parentGroup]="wpLegalEntityForm"
            [legalEntity]="this.legalEntityFormGroup"
            [merchant]="merchant"
          >
          </app-legal-entity-edit>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="legalEntityFormGroup.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
